export const STAGES = {
  INITIAL: "initial",
  SUCCESS: "success",
  ERROR: "error",
};

export const typeOptions = ["Artist", "Label"];

export const switchOptions = ["Yes", "No", "Unsure"];